/* tslint:disable */
/* eslint-disable */
/**
 * Mclarens.OutlookAddin.Api.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdhocContact } from './AdhocContact';
import {
    AdhocContactFromJSON,
    AdhocContactFromJSONTyped,
    AdhocContactToJSON,
} from './AdhocContact';

/**
 * 
 * @export
 * @interface AdhocContactsResponse
 */
export interface AdhocContactsResponse {
    /**
     * 
     * @type {Array<AdhocContact>}
     * @memberof AdhocContactsResponse
     */
    adhocContacts: Array<AdhocContact>;
    /**
     * 
     * @type {any}
     * @memberof AdhocContactsResponse
     */
    count: any | null;
}

/**
 * Check if a given object implements the AdhocContactsResponse interface.
 */
export function instanceOfAdhocContactsResponse(value: object): value is AdhocContactsResponse {
    if (!('adhocContacts' in value) || value['adhocContacts'] === undefined) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    return true;
}

export function AdhocContactsResponseFromJSON(json: any): AdhocContactsResponse {
    return AdhocContactsResponseFromJSONTyped(json, false);
}

export function AdhocContactsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdhocContactsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'adhocContacts': ((json['adhocContacts'] as Array<any>).map(AdhocContactFromJSON)),
        'count': json['count'],
    };
}

export function AdhocContactsResponseToJSON(value?: AdhocContactsResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'adhocContacts': ((value['adhocContacts'] as Array<any>).map(AdhocContactToJSON)),
        'count': value['count'],
    };
}

